// extracted by mini-css-extract-plugin
export default {"flagContainer":"Country_flagContainer__gWDUq","flagItem":"Country_flagItem__UWOrt","countryDetails":"Country_countryDetails__7I+Xa"};